import { City, CityGroupByCountry } from '@appTypes/api.types';

/** The individual departure cities out of the country groups `GetDepartureCitiesGroupedByCountry` returns. */
export function flattenDepartureCities(groups: readonly CityGroupByCountry[] | null | undefined): City[] {
  return (groups ?? []).flatMap((g) => g.cities ?? []);
}

/**
 * DEST-017: the departure city the Tours search form opens with.
 *
 * Order: the city the form already holds, when it is offered (a URL/query/saved-search value wins); else the
 * Destination Module's default for this agent (`defaultDepartureCityUID`), when offered; else the first city
 * offered. With nothing offered the form keeps what it holds - there is nothing better to show.
 */
export function pickDepartureCity(
  current: string | null | undefined,
  offered: readonly City[] | null | undefined,
  apiDefault: string | null | undefined
): string | null {
  const uids = (offered ?? []).map((c) => c.cityUID).filter((c): c is string => !!c);
  if (!uids.length) return current ?? null;
  if (current && uids.includes(current)) return current;
  if (apiDefault && uids.includes(apiDefault)) return apiDefault;
  return uids[0];
}
